import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
import qs from 'qs'
import store from '@/store'
import { getToken, removeToken, removeUserInfo } from '@/utils/auth'
import { Modal, Message } from 'view-design'
import router from '@/router'
// create an axios instance
//  axios.defaults.baseURL = '/develop-api'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})
let _config = {}
console.log('request', process.env.VUE_APP_BASE_API)
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // 更改请求头
    if (config.contentType === false) {
      // false 不设置请求头
      // config.headers['content-type'] =
      //   'application/json'
    } else {
      config.headers['content-type'] =
        'application/x-www-form-urlencoded;charset=UTF-8'
      // x-www要修改参数传输形式 拦截content-type类型变化引发的参数传输形式
      if (config.method === 'get') {
        config.params = config.data
      }
      if (config.method === 'post' || config.method === 'put') {
        config.data = qs.stringify(config.data)
      }
    }
    // if (config.excel === excel) {
    //     config.headers['content-type'] = 'application/vnd.ms-excel'
    // }
    //这个先放外边不知道为嘛store.getters.token为undefined
    config.headers['X-Token'] = getToken()
    config.headers['OPENTOKEN'] = localStorage.getItem('java-open-token')
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
    }
    _config = config
    console.log('config2', config)
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    console.log('response', response)

    /**
    * java导出
    */
    if (_config.isExport === true) {
      if (response.info) {
        Message.error('导出错误：' + response.info)
        return
      }
      const temp = response.headers['content-disposition']
        .split(';')[1]
        .split('=')[1]
      // 对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
      const iconv = require('iconv-lite')
      const fileName = iconv.decode(temp, 'gbk')
      if (window.navigator.msSaveOrOpenBlob) {
        // 兼容IE10
        navigator.msSaveBlob(blob, this.filename)
      } else {
        const blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel;charset=UTF-8'
        })
        const a = document.createElement('a')
        // 生成文件路径
        const href = window.URL.createObjectURL(blob)
        a.href = href
        // 文件名中有中文 则对文件名进行转码
        a.download = decodeURIComponent(fileName)
        // 利用a标签做下载
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(href)
      }
      return {}
    }

    const res = response.data
    if (res.code !== 200) {
      if (res.code === -996 || res.code === -401) {
        Message.error('登陆过期，请重新登录')
        store.dispatch('nav/changeIsGoOfficial', 0)
        store.dispatch('user/logout')
        if (store.state.user.isSaasProxyUser == 1) {
          router.push('/pc/proxyHome/index')
        } else {
          router.push('/')
        }
      } else {
        const tip = res.msg || res.message || res.info || '出错啦~'
        Message.error(tip)
        return Promise.reject((res.message || '出错啦~'))
      }
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message.error(error.message)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js